import React, { Fragment } from 'react'

import s from './CardHeading.scss'


const CardHeading = ({ headingTitle, city, date, title, image }) => (
  <Fragment>
    <div className={s.text}>
      {
        Boolean(city) && (
          <div>{city}</div>
        )
      }
      {
        Boolean(headingTitle) && (
          <div>{headingTitle}</div>
        )
      }
      {
        Boolean(date) && (
          <div>{date}</div>
        )
      }
    </div>
    <div className={s.title}>
      {title}
    </div>
    <img className={s.image} src={image} />
  </Fragment>
)


export default CardHeading
